import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useAuth } from '../../context/auth-provider';

export default function CallbackView() {
  const { handleOAuthCallback } = useAuth();
  const navigate = useNavigate();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');
    const errorDesc = params.get('error_description');

    // Clear query params from URL immediately
    window.history.replaceState({}, '', window.location.pathname);

    if (error) {
      console.error(`OAuth error: ${error} — ${errorDesc}`);
      // Redirect to login with error in state so SignInView can display it
      navigate('/', { replace: true, state: { oauthError: errorDesc || error } });
      return;
    }

    if (code) {
      handleOAuthCallback(code).then(() => {
        navigate('/', { replace: true });
      });
      return;
    }

    // No code or error — just go home
    navigate('/', { replace: true });
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: 2 }}>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">Completing sign in…</Typography>
    </Box>
  );
}
